export default "__VITE_ASSET__DQyydCx___"